export default __webpack_public_path__ + "static/media/newbie_project9.3a2e9451.jpg";